import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="border-y border-steel/30 bg-navy-900 py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-76" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-77" data-mp="9t1nv80r8fc2">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-3xl border-2 border-steel bg-navy-950 p-8 shadow-2xl shadow-black/40 sm:p-12" data-id="element-78" data-mp="etplwdnehwfs">
          <span className="inline-flex rounded-full border border-copper/50 bg-navy-900 p-4 text-copper" data-id="element-79" data-mp="smxdw6fe8ty0">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-80" data-mp="xlrv53xpqag0" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold uppercase tracking-tight text-white sm:text-4xl" data-id="element-81" data-mp="12gxhu4yxvt55">
            7-Day <span className="text-gold" data-id="element-82" data-mp="25rnkn44bquve">Guarantee</span>
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-steel-light" data-id="element-83" data-mp="25pua3dqlbqi4">
            Study all 6 volumes and 5 bonuses this week. If the technical depth doesn&apos;t match your professional
            needs,{' '}
            <span className="font-extrabold text-gold" data-id="element-84" data-mp="1rs5p85wiwjd2">we refund 100%. No questions. No complications.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}